export class LoginUser {
  public userId: number | null = null;
  public username: string | null = null;
}
